import { z } from "zod";

export const OfferSchema = z.object({
  id: z.string(),
  coachId: z.string(),
  username: z.string(),

  directSaleEnabled: z.boolean().nullable().optional(),
  price: z.number().min(0).nullable().optional(), // store as decimal, convert to cents in action
  currency: z.string().length(3).nullable().optional(), // e.g., "USD"
  originalPrice: z.number().min(0).nullable().optional(), // store as decimal, convert to cents in action

  preHeadline: z.string().nullable().optional(),
  headline: z.string().max(100).nullable().optional(),
  description: z.string().max(300).nullable().optional(),

  tags: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        offerId: z.string().optional(),
        property: z.string(),
        title: z.string().max(20),
        order: z.number().optional(),
      }),
    )
    .optional(),
  benefits: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        offerId: z.string().optional(),
        title: z.string(),
        content: z.string().nullable().optional(),
        imageSrc: z
          .union([z.string().url(), z.literal("")])
          .nullable()
          .optional(),
        order: z.number().optional(),
      }),
    )
    .optional(),

  testimonials: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        content: z.string(),
        author: z.string(),
        order: z.number().optional(),
      }),
    )
    .optional(),

  components: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        preHeader: z.string().nullable().optional(),
        title: z.string(),
        imageUrl: z.string().nullable().optional(),
        content: z.string(),
        order: z.number().optional(),
      }),
    )
    .optional(),

  vslVideoUrl: z.string().nullable().optional(),

  strugglesHeadline: z.string().nullable().optional(),
  strugglesDescription: z.string().nullable().optional(),
  strugglesImageUrl: z.string().nullable().optional(),

  resultsPreHeadline: z.string().nullable().optional(),
  resultsHeadline: z.string().nullable().optional(),
  resultsDescription: z.string().nullable().optional(),
  resultsImageUrl: z
    .union([z.string().url(), z.literal("")])
    .nullable()
    .optional(),

  programHeadline: z.string().nullable().optional(),
  programDescription: z.string().nullable().optional(),
  programImageUrl: z.string().nullable().optional(),

  bottomCtaHeadline: z.string().nullable().optional(),
  bottomCtaText: z.string().nullable().optional(),

  applicationDeadline: z
    .union([z.literal(""), z.string().date()])
    .nullable()
    .optional(),
  cohortStartDate: z
    .union([z.literal(""), z.string().date()])
    .nullable()
    .optional(),

  satisfactionGuaranteeText: z.string().nullable().optional(),

  bonuses: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        offerId: z.string().optional(),
        title: z.string(),
        content: z.string(),
        imageSrc: z
          .union([z.string().url(), z.literal("")])
          .nullable()
          .optional(),
        order: z.number().optional(),
      }),
    )
    .optional(),

  faqs: z
    .array(
      z.object({
        _delete: z.boolean().optional(),
        id: z.string().optional(),
        offerId: z.string().optional(),
        question: z.string(),
        answer: z.string(),
        order: z.number().optional(),
      }),
    )
    .optional(),
});
